<template>
  <div>
    <u-loader v-if="isLoading" />
    <div
      v-else
      class="legal-minimum-wage-exclusions"
    >
      <v-btn
        color="primary"
        class="mb-4 ml-4"
        :disabled="!canUserEdit"
        @click="addExclusion"
      >
        Neue Ausnahmeregel
      </v-btn>
      <v-expansion-panel>
        <v-expansion-panel-content
          v-for="(exclusion, exclusionIndex) in exclusions"
          :key="exclusionIndex"
          class="ml-4"
        >
          <div slot="header">
            <h6 class="float-left">
              {{ exclusion.title }}
            </h6>
            <button
              v-if="canUserEdit"
              v-b-tooltip.hover
              class="btn btn-danger float-right mr-2"
              placement="bottom"
              title="Ausnahmeregel löschen"
              type="button"
              @click.stop.prevent="deleteExclusion(exclusion)"
            >
              <i class="fas fa-trash-alt" />
            </button>
            <button
              v-if="canUserEdit"
              v-b-tooltip.hover
              class="btn btn-success float-right mr-2"
              placement="bottom"
              title="Ausnahemeregel speichern"
              type="button"
              @click.stop.prevent="saveExclusion(exclusion)"
            >
              <i class="fas fa-save" />
            </button>
          </div>
          <div class="ml-5">
            <v-text-field
              v-model="exclusion.title"
              label="Titel"
              outlined
              dense
              class="mb-2 w-50"
            />

            <div
              v-for="(
                filterGroup, filterGroupIndex
              ) in exclusion.exclusionFilters"
              :key="filterGroupIndex"
              class="w-100"
            >
              <v-card class="grouped-filters">
                <div class="group-title">
                  AND-Gruppe
                </div>
                <button
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="btn btn-danger actionButton mt-2 ml-4"
                  placement="bottom"
                  title="And-Gruppe löschen"
                  type="button"
                  @click="
                    deleteFilterGroup(
                      exclusion.exclusionFilters,
                      filterGroupIndex,
                    )
                  "
                >
                  <i class="fas fa-trash-alt" />
                </button>
                <div
                  v-for="(filter, filterIndex) in filterGroup.filters"
                  :key="filter.id + '_' + filterIndex"
                  class="col-12 d-flex"
                >
                  <criteria-groups-filter
                    v-model="filterGroup.filters[filterIndex]"
                    :contract-id="contractId"
                    :edition-id="editionId"
                    :readonly="!canUserEdit"
                    :version-id="versionId"
                    class="col-12"
                  />
                  <div>
                    <button
                      v-if="canUserEdit"
                      v-b-tooltip.hover
                      class="btn btn-danger deleteFilterActionButton"
                      placement="bottom"
                      title="Diesen Filter löschen"
                      type="button"
                      @click="removeListItem(filterGroup.filters, filterIndex)"
                    >
                      <i class="fas fa-trash-alt" />
                    </button>
                  </div>
                </div>
                <button
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="btn d-block btn-success actionButton mt-2 ml-4"
                  placement="bottom"
                  title="Neuer Filter hinzufügen"
                  type="button"
                  @click="addNewFilterItem(filterGroup.filters)"
                >
                  <i class="fas fa-plus" />
                </button>
              </v-card>
              <div
                v-if="filterGroupIndex + 1 < exclusion.exclusionFilters.length"
                class="or-label my-4 d-flex"
              >
                OR
              </div>
            </div>

            <div class="w-100">
              <button
                v-if="canUserEdit"
                v-b-tooltip.hover
                class="btn d-block btn-success actionButton mr-4 mb-2"
                placement="bottom"
                title="weitere AND-Gruppe hinzufügen"
                type="button"
                @click="addNewFilterGroup(exclusion)"
              >
                <i class="fas fa-plus" />
              </button>
            </div>
            <v-divider />
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </div>
  </div>
</template>

<script>
import CriteriaGroupsFilter from "../CriteriaGroups/CriteriaGroupsFilter.vue";
import {
  GetMinimalSalaryExclusions,
  AddMinimalSalaryExclusion,
  UpdateMinimalSalaryExclusion,
  DeleteMinimalSalaryExclusion,
} from "../../../../services/minimum.wage.services/canton.minimum.wages";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";

export default {
  name: "LegalMinimumWageExclusions",
  components: {
    CriteriaGroupsFilter,
  },
  mixins: [MinimumWageMixin],
  props: {
    configurationId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      exclusions: [],
      isLoading: false,
    };
  },
  created() {
    this.loadExclusions();
  },
  methods: {
    addExclusion() {
      let newExclusion = {
        id: 0,
        title: "Neue Ausnahmeregel",
        configurationId: this.configurationId,
        exclusionFilters: [],
      };
      this.exclusions.push(newExclusion);
      this.addNewFilterGroup(newExclusion);
    },
    addNewFilterGroup(exclusion) {
      var newGroup = {
        id: 0,
        filters: [],
        order: 0,
      };
      this.addNewFilterItem(newGroup.filters);
      exclusion.exclusionFilters.push(newGroup);
    },
    addNewFilterItem(list) {
      list.push({
        id: 0,
        operator: 1,
        value: "",
        order: 0,
      });
    },
    deleteFilterGroup(collection, index) {
      collection.splice(index, 1);
    },
    removeListItem(collection, index) {
      collection.splice(index, 1);
    },
    loadExclusions() {
      this.isLoading = true;
      GetMinimalSalaryExclusions(
        this.configurationId,
        (response) => {
          this.exclusions = response;
          this.isLoading = false;
        },
        (error) => {
          console.error("Error loading exclusions:", error);
          this.isLoading = false;
        },
      );
    },
    saveExclusion(exclusion) {
      this.isLoading = true;
      if (exclusion.id === 0) {
        AddMinimalSalaryExclusion(
          this.configurationId,
          exclusion,
          () => {
            this.loadExclusions();
            this.isLoading = false;
          },
          (error) => {
            console.error("Error adding exclusion:", error);
            this.isLoading = false;
          },
        );
      } else {
        UpdateMinimalSalaryExclusion(
          this.configurationId,
          exclusion,
          () => {
            this.loadExclusions();
            this.isLoading = false;
          },
          (error) => {
            console.error("Error updating exclusion:", error);
            this.isLoading = false;
          },
        );
      }
    },
    deleteExclusion(exclusion) {
      this.isLoading = true;
      if (exclusion.id === 0) {
        // If the exclusion hasn't been saved yet, just remove it from the list
        this.exclusions = this.exclusions.filter((e) => e !== exclusion);
        this.isLoading = false;
        return;
      }
      DeleteMinimalSalaryExclusion(
        this.configurationId,
        exclusion.id,
        () => {
          this.loadExclusions();
          this.isLoading = false;
        },
        (error) => {
          console.error("Error deleting exclusion:", error);
          this.isLoading = false;
        },
      );
    },
  },
};
</script>

<style scoped>
.grouped-filters {
  border: 1px solid rgb(160, 160, 160);
  padding: 15px 0px 20px;
  margin-left: 5px;
  width: calc(100% - 10px);
  position: relative;
}

.group-title {
  color: gray;
  position: absolute;
  top: -12px;
  left: 20px;
  background-color: white;
  padding: 0px 10px;
}

.actionButton {
  height: 34px;
  margin-top: 15px;
  margin-left: 10px;
}

.smallActionButton {
  width: 25px;
  height: 25px;
  font-size: 17px;
  padding: 0px;
}

.deleteFilterActionButton {
  height: 34px;
  margin-top: 15px;
  margin-left: 3px;
}
</style>
